import {Injectable} from '@angular/core';
import {ExtraFee} from '../../models/quote/extra-fee';
import {from, Observable} from 'rxjs';
import {ExtraFeeService} from "./extra-fee.service";
import {SqliteExtraFeeRepository} from "../../sqllite/repositories/params/sqlite-extra-fee.repository";

@Injectable()
export class StandaloneRemoteExtraFeeService extends ExtraFeeService {
    API_URL = '/apiParams/v1/extrafees';

    constructor(
        private readonly sqliteExtraFeeRepository: SqliteExtraFeeRepository) {
        super();
    }

    getExtraFeesByServiceAndCountryAndRole(): Observable<ExtraFee[]> {
        return from(this.sqliteExtraFeeRepository.getExtraFeesByCountry());
    }

}
